// extracted by mini-css-extract-plugin
export var alwaysVisible = "AnimatedTitle-module--alwaysVisible--a819d";
export var desktop = "AnimatedTitle-module--desktop--358ce";
export var mobile = "AnimatedTitle-module--mobile--22791";
export var title = "AnimatedTitle-module--title--588f1";